import React from "react";
import Body from "./Body";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const MiscellaneousCost = () => {
  const teacherList = [
    {
      itemCode: "T001",
      name: "Jahiruddin Chowdhury",
      teacherId: "#987650475",
      contact: "9876543210",
      designation: "Teaching associate",
      subject: "Biological sciences",
    },
    {
      itemCode: "T002",
      name: "Jahiruddin Chowdhury",
      teacherId: "#987650475",
      contact: "9876543210",
      designation: "Teaching associate",
      subject: "Biological sciences",
    },
    {
      itemCode: "T003",
      name: "Jahiruddin Chowdhury",
      teacherId: "#987650475",
      contact: "9876543210",
      designation: "Teaching associate",
      subject: "Biological sciences",
    },
    {
      itemCode: "T004",
      name: "Jahiruddin Chowdhury",
      teacherId: "#987650475",
      contact: "9876543210",
      designation: "Teaching associate",
      subject: "Biological sciences",
    },
    {
      itemCode: "T005",
      name: "Jahiruddin Chowdhury",
      teacherId: "#987650475",
      contact: "9876543210",
      designation: "Teaching associate",
      subject: "Biological sciences",
    },
    {
      itemCode: "T006",
      name: "Jahiruddin Chowdhury",
      teacherId: "#987650475",
      contact: "9876543210",
      designation: "Teaching associate",
      subject: "Biological sciences",
    },
    {
      itemCode: "T007",
      name: "Jahiruddin Chowdhury",
      teacherId: "#987650475",
      contact: "9876543210",
      designation: "Teaching associate",
      subject: "Biological sciences",
    },
    {
      itemCode: "T008",
      name: "Jahiruddin Chowdhury",
      teacherId: "#987650475",
      contact: "9876543210",
      designation: "Teaching associate",
      subject: "Biological sciences",
    },
  ];

  const teacherTableHeaders = [
    { key: "name", label: "Name" },
    { key: "contact", label: "Contact" },
    { key: "designation", label: "Designation" },
    { key: "subject", label: "Subjects" },
  ];

  const eventHistoryData = [
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Mock school inspection",
      description:
        "Inspection is near about two hours within a campus. Mainly school building. It touches a world class standard.",
      students: [
        { name: "1. Jahiruddin Chowdhury", quantity: "", amount: 18000 },
        { name: "2. Jahiruddin Chowdhury", quantity: "", amount: 0 },
        { name: "3. Jahiruddin Chowdhury", quantity: "", amount: 0 },
      ],
      totalAmount: 18000,
      paidAmount: 18000,
      paymentMethod: "UPI",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Mock school inspection",
      description:
        "Inspection is near about two hours within a campus. Mainly school building.",
      students: [{ name: "Jahiruddin Chowdhury", quantity: "", amount: 18000 }],
      totalAmount: 36000,
      paidAmount: 36000,
      paymentMethod: "Net banking",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Mock school inspection",
      description:
        "Inspection is near about two hours within a campus. Mainly school building.",
      students: [{ name: "Jahiruddin Chowdhury", quantity: "", amount: 18000 }],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Debit card",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Mock school inspection",
      description:
        "Inspection is near about two hours within a campus. Mainly school building. It touches a world class standard.",
      students: [{ name: "Jahiruddin Chowdhury", quantity: "", amount: 18000 }],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Mock school inspection",
      description:
        "Inspection is near about two hours within a campus. Mainly school building.",
      students: [{ name: "Jahiruddin Chowdhury", quantity: "", amount: 18000 }],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: null,
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
  ];

  const columns = [
    {
      label: "Receipt id/Time",
      key: "receiptId",
      render: (row) => (
        <>
          {row.receiptId}
          <br />
          <span style={{ color: "var(--orangeColor)", fontSize: "small" }}>
            {row.time}
          </span>
        </>
      ),
    },
    {
      label: "Feature name",
      key: "event",
      render: (row) => <>{row.event}</>,
    },
    {
      label: "Description",
      key: "description",
      render: (row) => <>{row.description}</>,
    },
    {
      label: "Total amount (INR)",
      key: "totalAmount",
      render: (row) => (
        <span>₹ {Number(row.totalAmount).toLocaleString("en-IN")}</span>
      ),
    },
    {
      label: "Paid amount (INR)",
      key: "paidAmount",
      render: (row) => (
        <>
          ₹ {Number(row.paidAmount).toLocaleString("en-IN")}
          <br />
          <span style={{ color: "var(--deepGreen3)", fontSize: "small" }}>
            {row.paymentMethod || "—"}
          </span>
        </>
      ),
    },
    {
      label: "Mentor/event",
      key: "vendor",
      render: (row) => (
        <>
          {row.vendor.name}
          <br />
          Ph:{" "}
          <span style={{ color: "var(--blueColor1)" }}>{row.vendor.phone}</span>
        </>
      ),
    },
    {
      label: "Confirmed by",
      key: "confirmedBy",
      render: (row) => (
        <span style={{ color: "var(--deepGreen3)" }}>{row.confirmedBy}</span>
      ),
    },
    {
      label: "Receipts",
      key: "receipts",
      render: (row) => (
        <>
          <span
            style={{
              color: "var(--blueColor1)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              cursor: "pointer",
            }}
          >
            Receipt <BsBoxArrowRight />
          </span>
          <br />
          <button
            className="action-pay-btn"
            style={{
              backgroundColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
              borderColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
            }}
          >
            {row.paidAmount < row.totalAmount ? "Pay due" : "All paid"}
          </button>
        </>
      ),
    },
  ];

  // Sample dropdown data
  const confirmedByOptions = ["Admin", "Finance Head", "CEO"];
  const paymentModes = ["Cash", "UPI", "Bank Transfer", "Cheque"];
  const _this = {
    teacherList,
    teacherTableHeaders,
    eventHistoryData,
    columns,
    confirmedByOptions,
    paymentModes,
  };
  return <Body {..._this} />;
};

export default MiscellaneousCost;
